// extracted by mini-css-extract-plugin
export default {"sec1":"Index_sec1__us11Q","sec2":"Index_sec2__elRcJ"};